// extracted by mini-css-extract-plugin
export default {"cd":"cd"};